export interface JwtPayloadBase {
  sub?: string;
  email?: string;
  role?: string;
  companyId?: string;
  exp?: number;
  iat?: number;
  [key: string]: unknown;
}

interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function getStorage(): StorageLike | null {
  const candidate = (globalThis as { localStorage?: StorageLike }).localStorage;
  return candidate ?? null;
}

export function getStoredValue(key: string): string | null {
  return getStorage()?.getItem(key) ?? null;
}

export function setStoredValue(key: string, value: string): void {
  getStorage()?.setItem(key, value);
}

export function removeStoredValue(key: string): void {
  getStorage()?.removeItem(key);
}

export function decodeJwtPayload<T extends JwtPayloadBase = JwtPayloadBase>(
  token: string | null | undefined,
): T | null {
  if (!token) {
    return null;
  }

  const parts = token.split('.');

  if (parts.length < 2) {
    return null;
  }

  try {
    const normalized = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
    const decoded = atob(padded);
    return JSON.parse(decoded) as T;
  } catch {
    return null;
  }
}
